<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="老师姓名：" prop="realName">
            <el-input v-model="query.realName" placeholder="请输入老师姓名" size="small" />
          </el-form-item>
          <el-form-item label="老师手机号：" prop="mobile">
            <el-input v-model="query.mobile" placeholder="请输入老师手机号" size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small" @change="handleTechnical">
              <el-option v-for="(item,index) in technicalServiceLevel" :key="index" :label="item.value"
                :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="管辖区域：">
            <el-cascader :props="cascaderProps" v-model="areaArr" :options="regionOptions" clearable size="small"></el-cascader>
          </el-form-item> -->
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-boxs mb10 w-100">
        <div class="font12">
          <el-date-picker v-model="quotaDate" value-format="yyyy" type="year" placeholder="选择年" size="mini"
            :clearable="false" @change="handleQuery">
          </el-date-picker>
          <!-- <span class="ml20">年标准：{{info.quota ||0}}</span>
          <span class="ml20">实际业绩：{{info.performance ||0}}</span>
          <span class="ml20">年完成率：{{info.completeRate ||0}}%</span> -->
        </div>
        <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="老师信息" prop="" align="center" fixed width="150">
          <template slot-scope="{row}">
            {{row.realName}}({{row.levelName}})<br />
            {{row.mobile}}
          </template>
        </el-table-column>
        <el-table-column label="1月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth1.quota || !row.quotaMonth1.performance)?0:Math.ceil((row.quotaMonth1.performance/row.quotaMonth1.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth1.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>1))" @change="handleChange(row,row.quotaMonth1.quota)" />
                <div>实际业绩：{{row.quotaMonth1.performance?row.quotaMonth1.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="2月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth2.quota || !row.quotaMonth2.performance)?0:Math.ceil((row.quotaMonth2.performance/row.quotaMonth2.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth2.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>2))" @change="handleChange(row,row.quotaMonth2.quota)" />
                <div>实际业绩：{{row.quotaMonth2.performance?row.quotaMonth2.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="3月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth3.quota || !row.quotaMonth3.performance)?0:Math.ceil((row.quotaMonth3.performance/row.quotaMonth3.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth3.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>3))" @change="handleChange(row,row.quotaMonth3.quota)" />
                <div>实际业绩：{{row.quotaMonth3.performance?row.quotaMonth3.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="4月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth4.quota || !row.quotaMonth4.performance)?0:Math.ceil((row.quotaMonth4.performance/row.quotaMonth4.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth4.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>4))" @change="handleChange(row,row.quotaMonth4.quota)" />
                <div>实际业绩：{{row.quotaMonth4.performance?row.quotaMonth4.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="5月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth5.quota || !row.quotaMonth5.performance)?0:Math.ceil((row.quotaMonth5.performance/row.quotaMonth5.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth5.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>5))" @change="handleChange(row,row.quotaMonth5.quota)" />
                <div>实际业绩：{{row.quotaMonth5.performance?row.quotaMonth5.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="6月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth6.quota || !row.quotaMonth6.performance)?0:Math.ceil((row.quotaMonth6.performance/row.quotaMonth6.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth6.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>6))" @change="handleChange(row,row.quotaMonth6.quota)" />
                <div>实际业绩：{{row.quotaMonth6.performance?row.quotaMonth6.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="7月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth7.quota || !row.quotaMonth7.performance)?0:Math.ceil((row.quotaMonth7.performance/row.quotaMonth7.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth7.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>7))" @change="handleChange(row,row.quotaMonth7.quota)" />
                <div>实际业绩：{{row.quotaMonth7.performance?row.quotaMonth7.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="8月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth8.quota || !row.quotaMonth8.performance)?0:Math.ceil((row.quotaMonth8.performance/row.quotaMonth8.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth8.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>8))" @change="handleChange(row,row.quotaMonth8.quota)" />
                <div>实际业绩：{{row.quotaMonth8.performance?row.quotaMonth8.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="9月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth9.quota || !row.quotaMonth9.performance)?0:Math.ceil((row.quotaMonth9.performance/row.quotaMonth9.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth9.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>9))" @change="handleChange(row,row.quotaMonth9.quota)" />
                <div>实际业绩：{{row.quotaMonth9.performance?row.quotaMonth9.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="10月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth10.quota || !row.quotaMonth10.performance)?0:Math.ceil((row.quotaMonth10.performance/row.quotaMonth10.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth10.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>10))" @change="handleChange(row,row.quotaMonth10.quota)" />
                <div>实际业绩：{{row.quotaMonth10.performance?row.quotaMonth10.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="11月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth11.quota || !row.quotaMonth11.performance)?0:Math.ceil((row.quotaMonth11.performance/row.quotaMonth11.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth11.quota" placeholder="请输入" size="small"
                  :disabled="(quotaDate<nowYear || (quotaDate==nowYear && nowMonth>11))" @change="handleChange(row,row.quotaMonth11.quota)" />
                <div>实际业绩：{{row.quotaMonth11.performance?row.quotaMonth11.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="12月(万)" prop="" width="170" align="center">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="`完成率：${(!row.quotaMonth12.quota || !row.quotaMonth12.performance)?0:Math.ceil((row.quotaMonth12.performance/row.quotaMonth12.quota) * 1000) / 10}%`" placement="bottom">
              <div class="flex-col items-start">
                <el-input v-model="row.quotaMonth12.quota" placeholder="请输入" size="small" :disabled="quotaDate<nowYear"
                  @change="handleChange(row,row.quotaMonth12.quota)" />
                <div>实际业绩：{{row.quotaMonth12.performance?row.quotaMonth12.performance:0}}</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="100">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,0)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <!-- <banner-add ref="bannerAdd" :standingList="standingList" :discountList="discountList" :configList="configList" :labelList="labelList" :businessList="businessList" :addressList="addressList" :technicianList="technicianList" :popType="popType" @created="doQueryList({})" /> -->
  </div>
</template>
<script>
  import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
  import technicianInfoApi from '@/api/technical/technicianInfo'
  import technicianQuotaApi from '@/api/technical/technicianQuota'
  export default {
    data() {
      return {
        list: [],
        total: 0,
        listLoading: false,
        query: {
          pageNo: 1,
          pageSize: 10,
        },
        quotaDate: null,
        cascaderProps: {
          label: 'regionName',
          value: 'regionCode',
          children: 'child',
        },
        regionOptions: [],
        technicalServiceLevel: [],
        nowYear: null,
        nowMonth: null,
        info: {}
      }
    },
    created() {
      this.nowYear = this.dayjs().year()
      this.nowMonth = this.dayjs().month() + 1
      this.quotaDate = String(this.nowYear)
      this.regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
      // this.regionOptions = regionOptions[0].children
      this.getOption()
      this.getStatistics()
      this.doQueryList({
        pageNo: 1
      })
    },
    methods: {
      handleChange(row,val) {
        // console.log('row: ', row,val);
        if(!/^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/.test(val))  return this.$message.warning('请输入正确的业绩')
        let query = {
          month1: row.quotaMonth1.quota * 1,
          month2: row.quotaMonth2.quota * 1,
          month3: row.quotaMonth3.quota * 1,
          month4: row.quotaMonth4.quota * 1,
          month5: row.quotaMonth5.quota * 1,
          month6: row.quotaMonth6.quota * 1,
          month7: row.quotaMonth7.quota * 1,
          month8: row.quotaMonth8.quota * 1,
          month9: row.quotaMonth9.quota * 1,
          month10: row.quotaMonth10.quota * 1,
          month11: row.quotaMonth11.quota * 1,
          month12: row.quotaMonth12.quota * 1
        }
        if (row.quotaId) {
          query.id = row.quotaId
          console.log('query: ', query);
          technicianQuotaApi.updateQuota(query)
        } else {
          query.technicianInfoId = row.id
          query.quotaDate = `${this.quotaDate}-01-01 00:00:00`
          technicianQuotaApi.createQuota(query)
          console.log('query: ', query);
        }
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      handleFilter() {
        this.query = {
          pageNo: 1,
          pageSize: 10,
        }
        this.doQueryList({
          pageNo: 1
        })
      },
      getOption() {
        technicalServiceLevelApi.findOptions().then(({
          data
        }) => {
          this.technicalServiceLevel = data
        })
      },
      getStatistics() {
        let query = {}
        query.quotaDateStart = `${this.quotaDate}-01-01 00:00:00`
        query.quotaDateEnd = `${this.quotaDate}-12-31 23:59:59`
        technicianQuotaApi.getServiceStatistics(query).then(({
          data
        }) => {
          console.log('统计: ', data);
          this.info = data
          // this.technicalServiceLevel = data
        })
      },
      doQueryList({
        pageNo,
        pageSize
      }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        let query = {
          ...this.query
        }
        query.quotaDateStart = `${this.quotaDate}-01-01 00:00:00`
        query.quotaDateEnd = `${this.quotaDate}-12-31 23:59:59`
        // if(this.areaArr && this.areaArr.length){
        //   query.provinceCode=this.areaArr[0]
        //   query.cityCode=this.areaArr[1]
        //   query.districtCode=this.areaArr[2]
        // }
        // if(this.dateTime && this.dateTime.length){
        //   if(this.query.isEnable==1){
        //     query.createdTimeStart=this.dateTime[0]
        //     query.createdTimeEnd=this.dateTime[1]
        //   }
        //   if(this.query.isEnable==2){
        //     query.resignTimeStart=this.dateTime[0]
        //     query.resignTimeEnd=this.dateTime[1]
        //   }
        //   if(this.query.isEnable==3){
        //     query.operatedTimeStart=this.dateTime[0]
        //     query.operatedTimeEnd=this.dateTime[1]
        //   }
        // }
        this.listLoading = true
        return technicianInfoApi.listForQuota(query)
          .then(data => {
            this.list = data.data.list
            this.total = data.data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      handleUpdate(row) {
        this.$router.push("/log/log?type=21&id=" + row.id);
      },
      handleDownload() {
        this.$router.push("/export/list?code=EEForTechInfoQuota")
      },
    }
  }
</script>
<style lang="scss" scoped>
  .btn-boxs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
</style>
